var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Activity',{attrs:{"title":_vm.t('app.main.title'),"vertical":"center"}},[_c('home-buttons',{attrs:{"items":_vm.buttons}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }